
import { Vue, Component } from "vue-property-decorator";
import { MODEL } from "./module";
import { CardType } from "./module/MODEL";

@Component
export default class App extends Vue {
  private selectedLocaleIndex = 0;
  private drawer = false;
  private menuItems: CardType[] = [MODEL.kinka, MODEL.buncho, MODEL.hatchan, MODEL.uni, MODEL.ema];
  get mobile(): boolean {
    return this.$vuetify.breakpoint.mobile;
  }
  private changeLocale(locale: string) {
    this.$i18n.locale = locale;
  }
  get availableLocales(): string[] {
    return this.$i18n.availableLocales;
  }
  get welcomeMessage(): string {
    return this.$t("common.welcome_msg", {
      msg: this.$t(`organization.${this.$store.state.cardType.organization_type}.name`, {
        msg: this.$t(`bird.${this.$store.state.cardType.bird_type}`),
      }),
    }).toString();
  }
  created() {
    const i = this.$i18n.availableLocales.indexOf(this.$i18n.locale);
    this.selectedLocaleIndex = i;
  }
}
